import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container mx-auto py-6" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 mb-8 hidden sm:block md:grid" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 1 Year Performance ")
const _hoisted_4 = { class: "flex flex-row items-center" }
const _hoisted_5 = { class: "flex-1 flex flex-row justify-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-300 w-px h-32 rounded" }, null, -1)
const _hoisted_7 = { class: "flex-1 flex flex-row justify-center" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 5 Year Performance ")
const _hoisted_9 = { class: "flex flex-row items-center" }
const _hoisted_10 = { class: "flex-1 flex flex-row justify-center" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-300 w-px h-32 rounded" }, null, -1)
const _hoisted_12 = { class: "flex-1 flex flex-row justify-center" }
const _hoisted_13 = { class: "flex flex-col sm:flex-row items-center justify-end pl-4 pr-2 sm:px-0" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "Edit Template", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "flex-1" }, "Add Budget", -1)
const _hoisted_16 = { class: "border-l border-dark-primary border-opacity-25 ml-4 pl-2" }
const _hoisted_17 = { class: "grid grid-cols-4 gap-3" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "grid grid-cols-2 sm:grid-cols-4 gap-2 text-gray-900" }, [
  /*#__PURE__*/_createVNode("div", { class: "hidden sm:block" }),
  /*#__PURE__*/_createVNode("div", null, "Name"),
  /*#__PURE__*/_createVNode("div", { class: "hidden sm:block" }, "Saved"),
  /*#__PURE__*/_createVNode("div", null, "Actions")
], -1)
const _hoisted_19 = {
  key: 0,
  class: "py-8 text-gray-500 flex flex-col items-center justify-center"
}
const _hoisted_20 = { class: "hidden sm:flex flex-row justify-start pl-16" }
const _hoisted_21 = { class: "pl-4 sm:pl-0" }
const _hoisted_22 = { class: "hidden sm:block" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")
  const _component_BudgetModal = _resolveComponent("BudgetModal")
  const _component_CustomBudgetModal = _resolveComponent("CustomBudgetModal")
  const _component_CardHeader = _resolveComponent("CardHeader")
  const _component_YTDSummary = _resolveComponent("YTDSummary")
  const _component_CardContent = _resolveComponent("CardContent")
  const _component_Card = _resolveComponent("Card")
  const _component_EditIcon = _resolveComponent("EditIcon")
  const _component_Button = _resolveComponent("Button")
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")
  const _component_SubNavItems = _resolveComponent("SubNavItems")
  const _component_SubNav = _resolveComponent("SubNav")
  const _component_Select = _resolveComponent("Select")
  const _component_SideBar = _resolveComponent("SideBar")
  const _component_WarningIcon = _resolveComponent("WarningIcon")
  const _component_TrendDownIcon = _resolveComponent("TrendDownIcon")
  const _component_TrendUpIcon = _resolveComponent("TrendUpIcon")
  const _component_FireIcon = _resolveComponent("FireIcon")
  const _component_BanIcon = _resolveComponent("BanIcon")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_ConfirmationModal, {
      title: "Remove Budget",
      text: "Are you sure you want to remove this budget?",
      show: _ctx.showConfirmModal,
      "onUpdate:show": _cache[1] || (_cache[1] = $event => (_ctx.showConfirmModal = $event)),
      onConfirm: _cache[2] || (_cache[2] = $event => (_ctx.confirmRemoveBudget()))
    }, null, 8, ["show"]),
    _createVNode(_component_BudgetModal, {
      show: _ctx.showBudgetModal,
      "onUpdate:show": _cache[3] || (_cache[3] = $event => (_ctx.showBudgetModal = $event))
    }, null, 8, ["show"]),
    _createVNode(_component_CustomBudgetModal, {
      show: _ctx.showCustomBudgetModal,
      "onUpdate:show": _cache[4] || (_cache[4] = $event => (_ctx.showCustomBudgetModal = $event))
    }, null, 8, ["show"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Card, { class: "hidden sm:block" }, {
          default: _withCtx(() => [
            _createVNode(_component_CardHeader, { class: "text-gray-700" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_CardContent, null, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode(_component_YTDSummary, {
                      color: "#45ADA8",
                      percentage: "65",
                      text: "Saved since last year."
                    })
                  ]),
                  _hoisted_6,
                  _createVNode("div", _hoisted_7, [
                    _createVNode(_component_YTDSummary, {
                      color: "#C62828",
                      percentage: "3",
                      text: "Spent since last year."
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_Card, { class: "hidden md:block" }, {
          default: _withCtx(() => [
            _createVNode(_component_CardHeader, { class: "text-gray-700" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_CardContent, null, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode(_component_YTDSummary, {
                      color: "#45ADA8",
                      percentage: "93",
                      text: "Saved over 5 years."
                    })
                  ]),
                  _hoisted_11,
                  _createVNode("div", _hoisted_12, [
                    _createVNode(_component_YTDSummary, {
                      color: "#C62828",
                      percentage: "1",
                      text: "Spent over 5 years."
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode(_component_Button, {
          color: "secondary",
          class: "mb-4 sm:mb-0 w-full sm:w-auto",
          onClick: _cache[5] || (_cache[5] = $event => (_ctx.goToTemplatePage()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_EditIcon, { class: "w-4 h-4 mr-2" }),
            _hoisted_14
          ]),
          _: 1
        }),
        _createVNode(_component_SubNav, { class: "w-full sm:w-auto mr-2 sm:mr-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              color: "primary",
              class: "mb-4 sm:mb-0 w-full sm:w-auto pr-2",
              "onOn-click": _cache[6] || (_cache[6] = $event => (_ctx.showAddBudgetNav = !_ctx.showAddBudgetNav)),
              onBlur: _cache[7] || (_cache[7] = $event => (_ctx.showAddBudgetNav = false))
            }, {
              default: _withCtx(() => [
                _hoisted_15,
                _createVNode("span", _hoisted_16, [
                  _createVNode(_component_ChevronDownIcon, { class: "w-5 h-5" })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_SubNavItems, {
              items: _ctx.addBudgetItems,
              show: _ctx.showAddBudgetNav,
              "onNav-clicked": _cache[8] || (_cache[8] = $event => (_ctx.handleNavClick($event)))
            }, null, 8, ["items", "show"])
          ]),
          _: 1
        }),
        _createVNode(_component_Select, {
          class: "block md:hidden w-full sm:w-40",
          placeholder: "Select a year",
          value: _ctx.selectedYear,
          "onUpdate:value": _cache[9] || (_cache[9] = $event => (_ctx.selectedYear = $event)),
          items: _ctx.years
        }, null, 8, ["value", "items"])
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode(_component_SideBar, {
          title: "Years",
          items: _ctx.years,
          "selected-item": _ctx.selectedYear,
          "onUpdate:selected-item": _cache[10] || (_cache[10] = $event => (_ctx.selectedYear = $event))
        }, null, 8, ["items", "selected-item"]),
        _createVNode(_component_Card, { class: "col-span-4 md:col-span-3 ml-3 mr-4 sm:mx-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_CardHeader, { class: "bg-gray-100 rounded-t-lg" }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }),
            _createVNode(_component_CardContent, { class: "px-0" }, {
              default: _withCtx(() => [
                (
							!_ctx.budgets[_ctx.selectedYear] ||
								!_ctx.budgets[_ctx.selectedYear].length
						)
                  ? (_openBlock(), _createBlock("div", _hoisted_19, [
                      _createVNode(_component_WarningIcon, { class: "w-8 h-8" }),
                      _createVNode("span", null, "There are no budgets for " + _toDisplayString(_ctx.selectedYear), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.budgets[_ctx.selectedYear], (item) => {
                  return (_openBlock(), _createBlock("div", {
                    key: item.id,
                    class: "grid grid-cols-2 sm:grid-cols-4 gap-2 text-gray-700 py-4 even:bg-gray-100 items-center"
                  }, [
                    _createVNode("div", _hoisted_20, [
                      (item.saved < 0)
                        ? _createVNode(_component_TrendDownIcon, {
                            key: 0,
                            class: "text-danger w-8 h-8"
                          })
                        : _createCommentVNode("", true),
                      (item.saved >= 0)
                        ? _createVNode(_component_TrendUpIcon, {
                            key: 1,
                            class: "text-primary w-8 h-8"
                          })
                        : _createCommentVNode("", true),
                      (item.saved === _ctx.maxSaved)
                        ? _createVNode(_component_FireIcon, {
                            key: 2,
                            class: "text-orange-400 w-8 h-8"
                          })
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_21, _toDisplayString(item.name), 1),
                    _createVNode("div", _hoisted_22, " $" + _toDisplayString(_ctx.formatDollar(item.saved.replace('-', ''))), 1),
                    _createVNode("div", null, [
                      _createVNode(_component_Button, {
                        color: "secondary",
                        fab: "",
                        "onOn-click": $event => (_ctx.goToEditPage(item.id))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_EditIcon, { class: "w-4 h-4" })
                        ]),
                        _: 1
                      }, 8, ["onOn-click"]),
                      _createVNode(_component_Button, {
                        color: "danger",
                        fab: "",
                        onClick: $event => (_ctx.setDeleteAndShowConfirmation(item.id))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_BanIcon, { class: "w-4 h-4 text-white" })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}